export default __webpack_public_path__ + "static/media/full_star.94171987.svg";